import {
    IProduct,
    IProductQuery,
    QueryKeys,
    useDelete,
    useItem,
    UseItemParams,
    useList,
    UseListParams,
    useSave,
} from '../../shared';
import { productsClient } from '../clients';

const client = productsClient;
const listKey = QueryKeys.Products;
const itemKey = QueryKeys.Product;

export function useProductsList(...args: UseListParams<IProduct, IProductQuery>) {
    return useList(client, listKey, ...args);
}

export function useProduct(...args: UseItemParams<IProduct>) {
    return useItem(client, itemKey, ...args);
}

export function useSaveProduct() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteProduct() {
    return useDelete(client, listKey);
}
